import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`

:root {
  --white: white;
  --black: black;
  --trasparent: trasparent;
  --border-color: ${({ theme }) => theme['border-color']};
  --primary30: ${({ theme }) => theme.primary30};
  --primary40: ${({ theme }) => theme.primary40};
  --primary50: ${({ theme }) => theme.primary50};
  --primary60: ${({ theme }) => theme.primary60};
  --primary70: ${({ theme }) => theme.primary70};
  --secondary30: ${({ theme }) => theme.secondary30};
  --secondary40: ${({ theme }) => theme.secondary40};
  --secondary50: ${({ theme }) => theme.secondary50};
  --secondary60: ${({ theme }) => theme.secondary60};
  --secondary70: ${({ theme }) => theme.secondary70};
  --danger30: ${({ theme }) => theme.danger30};
  --danger40: ${({ theme }) => theme.danger40};
  --danger50: ${({ theme }) => theme.danger50};
  --danger60: ${({ theme }) => theme.danger60};
  --danger70: ${({ theme }) => theme.danger70};
  --blue: ${({ theme }) => theme.blue};
  --green: ${({ theme }) => theme.green};
  --indigo: ${({ theme }) => theme.indigo};
  --orange: ${({ theme }) => theme.orange};
  --pink: ${({ theme }) => theme.pink};
  --purple: ${({ theme }) => theme.purple};
  --red: ${({ theme }) => theme.red};
  --teal: ${({ theme }) => theme.teal};
  --yellow: ${({ theme }) => theme.yellow};
  --gray1: ${({ theme }) => theme.gray1};
  --gray2: ${({ theme }) => theme.gray2};
  --gray3: ${({ theme }) => theme.gray3};
  --gray4: ${({ theme }) => theme.gray4};
  --gray5: ${({ theme }) => theme.gray5};
  --gray6: ${({ theme }) => theme.gray6};

  --primary: ${({ theme }) => theme.primary};
  --primary-focus: ${({ theme }) => theme['primary-focus']};
  --focus: ${({ theme }) => theme.focus};
  --active: ${({ theme }) => theme.active};
  --secondary: ${({ theme }) => theme.secondary};
  --disabled-dark: #3B3B3B;
  --disabled-light: #C4C4C4;
}

.root {
  color: var(--primaryAPPL);
}

a.btn-xyz {
  text-decoration: none;
}

.btn-xyz {
  display: inline-block;
  align-items: center;
  text-align: center;
  font-size: 14px;
  justify-content: center;
  border: 0.1em solid #ffffff;
  box-sizing: border-box;
  text-decoration: none;
  font: 400 13.3333px Arial;
  transition: all 0.2s;
  cursor: pointer;
  user-select: none;
}


.btn-xyz:focus {
  outline: none;
}

.btn-xyz:hover {
  outline: none;
}

.btn-xyz:disabled {
  outline: none;
}

.btn--primary--solid {
  background-color: var(--primary50);
  opacity: 1;
  color: currentColor;
}

.btn--primary--solid:active {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--primary50);
  color: var(--primary50);
}

.btn--primary--solid:hover {
  opacity: 0.7;
  transition: none;
}

.btn--primary--solid:disabled {
  border: 0.1em solid var(--border-color);
  background-color: var(--primary50);
  color: var(--white);
  opacity: 0.4;
}



.btn--primary--text {
  background-color: var(--trasparent);
  border: 0.1em solid var(--trasparent);
  opacity: 1;
  color: var(--primary50);
}

.btn--primary--text:active {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--trasparent);
  color: currentColor;
}

.btn--primary--text:hover {
  opacity: 0.7;
  transition: none;
}

.btn--primary--text:disabled {
  border: 0.1em solid var(--trasparent);
  background-color: var(--trasparent);
  color: var(--primary50);
  opacity: 0.4;
}

.btn--primary--outline {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--primary50);
  color: var(--primary50);
}



.btn--primary--outline:hover {
  opacity: 0.7;
  transition: none;
}

.btn--primary--outline:disabled {
  border: 0.1em solid var(--primary50);
  background-color: var(--transparent);
  color: var(--primary50);
  opacity: 0.4;
}

.btn--secondary--solid {
  background-color: var(--secondary50);
  opacity: 1;
  color: var(--white);
}
.btn--secondary--solid:hover {
  opacity: 0.7;
  transition: none;
}

.btn--secondary--solid:focus {
  background-color: var(--focus);
  border: 0.1em solid var(--secondary50);
  opacity: 1;
  color: var(--secondary50);
}

.btn--secondary--outline {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--secondary50);
  color: var(--secondary50);
}

.btn--secondary--outline:focus {
  background-color: var(--focus);
  opacity: 1;
  color: var(--secondary50);
}

.btn--secondary--outline:hover {
  opacity: 0.7;
  transition: none;

}

.btn--secondary--outline:disabled {
  border: 0.1em solid var(--border-color);
  background-color: var(--transparent);
  color: var(--secondary50);
  opacity: 0.4;
}

.btn--danger--solid {
  background-color: var(--danger50);
  opacity: 1;
  color: var(--white);
}
.btn--danger--solid:hover {
  opacity: 0.7;
  transition: none;
}

.btn--danger--solid:focus {
  background-color: var(--focus);
  border: 0.1em solid var(--danger50);
  opacity: 1;
  color: var(--danger50);
}

.btn--danger--outline {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--danger50);
  border-radius: 1.12em;
  color: var(--danger50);
}

.btn--danger--outline:focus {
  background-color: var(--focus);
  opacity: 1;
  color: var(--danger50);
}

.btn--danger--outline:hover {
  opacity: 0.7;
  transition: none;

}

.btn--danger--outline:disabled {
  border: 0.1em solid var(--border-color);
  background-color: var(--transparent);
  color: var(--danger50);
  opacity: 0.4;
}

.btn--round {
  border-radius: 1.12em;
}

.btn--square {
  border-radius: 0.22em;
}

.btn--xs {
  padding: 0 0.6rem 1.2px 0.6rem;
  margin: 0.6em;
}

.btn--sm {
  padding: 0.2em 1.6em;
  margin: 0.6em;
  font-size: 15px;
}

.btn--md {
  padding: 0.3em 2em;
  margin: 0.6em;
  font-size: 16px;
}

.btn--lg {
  padding: 0.4em 2.4em;
  margin: 0.6em;
  font-size: 17px;
}

.btn--xl {
  padding: 0.5em 2.8em;
  margin: 0.6em;
  font-size: 18px;
}

body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-family: "Proxima Nova", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-weight: 400;
  }

::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.scrollbartrackbgcolor};
}

::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.scrollbarbgcolor};
    border-radius: 0px;
    border: ${({ theme }) => theme.scrollbarborder};
}

.MuiToolbar-root {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.bartext};
}

.MuiBottomNavigation-root {
    background: ${({ theme }) => theme.bottomnavbgcolor};
}

.MuiToolbar-root.MuiToolbar-regular.toolbar-style.MuiToolbar-gutters {
    padding: 0 16px !important;

}
.MuiPaper-root.MuiDrawer-paper.paper.makeStyles-drawerClose-8.MuiDrawer-paperAnchorLeft.MuiDrawer-paperAnchorDockedLeft.MuiPaper-elevation0 {
    border-right: #878787 dotted 0.1px;
}
.MuiPaper-root.MuiDrawer-paper.paper.makeStyles-drawerOpen-7.MuiDrawer-paperAnchorLeft.MuiDrawer-paperAnchorDockedLeft.MuiPaper-elevation0 {
    border-right: #878787 dotted 0.1px;
}
hr.MuiDivider-root {
    border-bottom: #878787 solid 0.1px;
}
.toolbar-style {
    background: ${({ theme }) => theme.bar};
    color: ${({ theme }) => theme.bartext};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiTypography-colorTextSecondary {
    color: ${({ theme }) => theme.textsecondary};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.tag-color {

    color: ${({ theme }) => theme.tagcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.bottom-border {
    border-bottom: ${({ theme }) => theme.bottomborder};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.logo-img {
    background-image: ${({ theme }) => theme.logoimg};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.git-img {
    background-image: ${({ theme }) => theme.gitimg};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}


.img-border {
    border: ${({ theme }) => theme.imgborder};
    border-radius: 5%;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.small-img-border {
    border: ${({ theme }) => theme.imgborder};
    border-radius: 15%;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}


.npm-box {
    box-shadow: rgb(95, 13, 13) 0px 0px 15px 0px, rgb(95, 13, 13) 0px 0px 0px 0px, rgb(95, 13, 13) 0px 0px 0px 0px;
    background-color: ${({ theme }) => theme.npmbackground};
    border: 1px solid rgb(204 0 0 / 49%);
    opacity: ${({ theme }) => theme.npmopacity};
}

.npm-box:hover {
    box-shadow: rgb(95, 13, 13) 0px 0px 20px 0px, rgb(95, 13, 13) 0px 0px 0px 0px, rgb(95, 13, 13) 0px 0px 0px 0px;
    background-color: ${({ theme }) => theme.npmbackground};
    border: 1px solid rgb(204 0 0 / 69%);
    opacity: 0.8;
}


.git-box {
    box-shadow: ${({ theme }) => theme.gitshadow};
    background-color: ${({ theme }) => theme.gitbackground};
    border: ${({ theme }) => theme.gitborder};
    opacity: ${({ theme }) => theme.gitopacity};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}


.git-box:hover {
    box-shadow: ${({ theme }) => theme.gitshadowhover};
    background-color: ${({ theme }) => theme.gitbackground};
    border: ${({ theme }) => theme.gitborderhover};
    opacity: 0.8;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.dbfc {
    box-shadow: ${({ theme }) => theme.dbcshadow};
    background-color: ${({ theme }) => theme.dbcbackground};
    border: ${({ theme }) => theme.dbcborder};
    opacity: 0.7;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.dbfc:hover {
    box-shadow: ${({ theme }) => theme.dbcshadowhover};
    background-color: ${({ theme }) => theme.dbcbackground};
    border: ${({ theme }) => theme.dbcborderhover};
    opacity: 0.9;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.button-border {
    border: ${({ theme }) => theme.buttonborder};
    border-radius: 2%;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.icon-color {
    color: ${({ theme }) => theme.iconcolor};
}

.bar-shadow {
    box-shadow: ${({ theme }) => theme.barshadow};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.menu-icon {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}
.bar-title {
    color: ${({ theme }) => theme.bartext};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    letter-spacing: 0.2rem;
    text-transform: uppercase;
}

.icon {
    color: ${({ theme }) => theme.iconcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.link-style, .link-style:hover {
    color: ${({ theme }) => theme.text};
    text-decoration: none;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.list-style {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}


.theme-position {
    color: ${({ theme }) => theme.text};
    position: unset;
    margin-top: 18px;
}

.global-container {
    color: ${({ theme }) => theme.text};
    background: ${({ theme }) => theme.globalbackground};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

p.MuiTypography-root.MuiDropzoneArea-text.MuiTypography-h5 {
    color: ${({ theme }) => theme.inverse};
}


.MuiChip-root.MuiChip-outlined.MuiChip-deletable {
    color: ${({ theme }) => theme.iconcolor};
    border: ${({ theme }) => theme.borderstyle};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

svg.MuiSvgIcon-root.MuiChip-deleteIcon {
    color: ${({ theme }) => theme.iconcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.drawer-color {
    background: ${({ theme }) => theme.menubackground};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.drawer-text {
    color: ${({ theme }) => theme.menutextcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.MuiPaper-root.MuiDrawer-paper.MuiDrawer-paperAnchorRight.MuiPaper-elevation16 {
    background: ${({ theme }) => theme.menubackground};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.paper {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    border-right: #878787 dotted 0.1px;
}

.text-color {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.backround-color {
    background: ${({ theme }) => theme.body};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.text-secondary {
    color: ${({ theme }) => theme.textsecondary};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}
.body-content {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.divider {
    color: ${({ theme }) => theme.divider};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

  }

  .dev-ops-container {
    width: 100%;
  }


  .card-body-color {
    background: ${({ theme }) => theme.cardbg};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.card-text-color {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}
.card-shadow-color {
    box-shadow: ${({ theme }) => theme.cardshadow};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}



svg.MuiSvgIcon-root.MuiSelect-icon.MuiSelect-iconOutlined {
    color: ${({ theme }) => theme.textfieldtextcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.PrivateNotchedOutline-legendLabelled-8 {
    -webkit-transition: max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms;

}

.text-field-style {
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    & input {
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & textarea {
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & select {
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & select:not([multiple]) > option {
        background: ${({ theme }) => theme.cardbg};
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & label {
        color: ${({ theme }) => theme.textfieldtextcolor};

    }
    & label.Mui-focused {
        color: ${({ theme }) => theme.textfieldtextcolor};

    },
    & .MuiInput-underline:after {
        border-bottom-color: #3f3f3f;
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    },
    & .MuiOutlinedInput-root {
        & fieldset {
            border-color: ${({ theme }) => theme.textfieldoutlinecolor};
        },
        &:hover fieldset {
            border-color: ${({ theme }) => theme.textfieldoutlinecolorhover};
        },
        &.Mui-focused fieldset {
            border-color: #9b9b9b;
        },
    

    }
}

${
  '' /* & input:valid + fieldset {
    border-color: var(--green);
    color: var(--green);
},
& input:invalid + fieldset {
    border-color: var(--red);
    color: var(--red);
} */
}

.text-field-light-style {
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    & input {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & textarea {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & select {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & select:not([multiple]) > option {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & label {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};

    }
    & label.Mui-focused {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};

    },
    & .MuiInput-underline:after {
        border-bottom-color: #3f3f3f;
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    },
    & .MuiOutlinedInput-root {
        & fieldset {
            border-color: ${({ theme }) => theme.lighttextfieldoutlinecolor};
        },
        &:hover fieldset {
            border-color: ${({ theme }) =>
              theme.lighttextfieldoutlinecolorhover};
        },
        &.Mui-focused fieldset {
            border-color: #9b9b9b;
        },
    

    }
}



${
  '' /* & input:valid + fieldset {
    border-color: var(--green);
    color: var(--green);
},
& input:invalid + fieldset {
    border-color: var(--red);
    color: var(--red);
} */
}


.MuiStepIcon-root.MuiStepIcon-active {
    color: #545454;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiStepIcon-root.MuiStepIcon-completed {
    color: #b53f3f;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}


.MuiRadio-colorSecondary.Mui-checked {
    color: #b53f3f;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiIconButton-colorSecondary {
    color: #b53f3f;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiRadio-colorPrimary.Mui-checked {
    color: #004a99;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiIconButton-colorPrimary {
    color: #004a99;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}



span.MuiTypography-root.MuiStepLabel-label.MuiStepLabel-alternativeLabel.MuiStepLabel-active.MuiTypography-body2.MuiTypography-displayBlock {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}


span.MuiTypography-root.MuiStepLabel-label.MuiStepLabel-alternativeLabel.MuiTypography-body2.MuiTypography-displayBlock {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}




.button-color {
    color: ${({ theme }) => theme.buttontextcolor};
    background: ${({ theme }) => theme.buttonbgcolor};
    box-shadow: ${({ theme }) => theme.cardshadow};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.button-color:hover {
    background: ${({ theme }) => theme.buttonbgcolorhover};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}


.MuiButtonGroup-groupedOutlinedHorizontal {
    /* border-right-color: white; */
    border-color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.MuiButtonGroup-groupedOutlinedHorizontal:not(:last-child) {
    /* : transparent; */
    border-right-color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

input {
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.MuiButton-root.Mui-disabled {
    color: ${({ theme }) => theme.disabledtextcolor};
}

.MuiButton-outlined.Mui-disabled {
    border: 1px solid ${({ theme }) => theme.disabledtextcolor};
}






















#designer {
    background: radial-gradient(
        circle at 20% 128%,
        #2b31fa 15%,
        #ab771d 35%,
        #9e1b3c 55%,
        #178085 75%,
        #d60000 95%
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    border-style: groove;
    border-width: 1px;
}
#super {
    border-style: double;
    border-width: 1px;
    border-color: rgb(131, 131, 131);
}
#photographer {
    border: dotted;
    border-width: 1px;
    border-color: rgb(10, 10, 10);
}
#developer {
    border-width: 1px;
    border-color: rgb(236, 236, 236);
    border-style: dotted;
}
#admin-badge {
    border-width: 1px;
    border-color: rgb(214, 214, 214);
    border-style: dotted;
}

/*
 Social Media Icons Styles
 */

.insta {
    background: radial-gradient(
        circle at 30% 107%,
        #fdf497 0%,
        #fdf497 5%,
        #fd5949 45%,
        #d6249f 60%,
        #285aeb 90%
    );
    -webkit-background-clip: text;
    /* Also define standard property for compatibility */
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.linkedin {
    color: #0074b0;
}
.twitter {
    color: #1da1f2;
}

.facebook {
    color: #4064ad;
}
.whatsapp {
    color: #4dc85b;
}
.telegram {
    color: #2ea5df;
}
.snapchat {
    color: #fffc00;
}












  `
